export default __webpack_public_path__ + "static/media/bg.cf6f057f.png";